module.exports = __webpack_public_path__ + "img/income-and-expense-log_B09K1TTGQ1.8e7ead7f.jpg";